export default "__VITE_ASSET__9433b19a__"